export function updateEnrollments(enrollments){
    return {type:"UPDATE_ENROLLMENTS", enrollments}
}

export function updateEmployee(employee){
    return {type:"UPDATE_EMPLOYEE", employee}
}

export function updateContact(contact){
    return {type:"UPDATE_CONTACT", contact}
}
export function updateContacts(contacts){
    return {type:"UPDATE_CONTACTS", contacts}
}
export function addAttachment(attachment){
    return {type:"ADD_ATTACHMENT", attachment}
}
export function removeAttachment(category){
    return {type:"REMOVE_ATTACHMENT", category}
}

export function updateDependent(contact){
    return {type:"UPDATE_DEPENDENT", contact}
}

export function deleteDependent(dependentId){
    return {type:"DELETE_DEPENDENT", dependentId}
}

export function updateStep(step){
    return {type:"UPDATE_STEP", step}
}

export function updateSelection(selection){
    return {type:"UPDATE_SELECTION", selection}
}
export function updateInsurance(selections){
    return {type:"UPDATE_INSURANCE", selections}
}
export function updateFsa(selections){
    return {type:"UPDATE_FSA", selections}
}

export function updateEnollmentsType(enrollmentsType){
    return {type:"UPDATE_ENROLLMENTSTYPE", enrollmentsType}
}